import { Model } from '@shared/models/model';
import { Expose, Type } from 'class-transformer';
import { User } from '../../users/models/user.model';
import { Truck } from '../../fleets/models/truck.model';
import { Nationality } from '../../shared-features/enums/fleets.enum';
import { Fleet } from '../../fleets/models/fleet.model';

export class Tracking extends Model {
  @Expose() id: number;
  @Expose() driverId: number;
  @Expose() shipmentId: number;
  @Expose() longitude: number;
  @Expose() latitude: number;
  @Expose() state: string;
  @Expose() selected: boolean;
  @Expose() nationality: Nationality;
  @Type(() => User)
  @Expose() user: User = new User();
  @Type(() => Truck)
  @Expose() truck: Truck = new Truck();
  @Type(() => Fleet)
  @Expose() fleet: Fleet = new Fleet();
  @Expose() createdAt: string;
  @Expose() date: string;
  @Expose() plateNumber: string;

  constructor() {
    super();
  }
}
